import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=07cb327e&scoped=true&"
var script = {}
import style0 from "./Alert.vue?vue&type=style&index=0&id=07cb327e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cb327e",
  null
  
)

export default component.exports